export const DurationList = [
  { label: 'Daily', value: 'daily', text: 'per day' },
  { label: 'Weekly', value: 'weekly', text: 'per week' },
  { label: 'Monthly', value: 'monthly', text: 'per month' },
  { label: '3 Months', value: '3 Months', text: 'per 3 months' },
  { label: '6 Months', value: '6 Months', text: 'per 6 months' },
  { label: '1 Year', value: '1 Year', text: 'per year' },
  { label: 'fixed', value: 'fixed', text: 'fixed' },
]
